import $ from 'jquery';
import { debounce } from '../utils/functions';

const $window = $(window);
const $title = $('.banner__title');
const $container = $title.closest('.banner__half');

if ($title.length > 0) {
    $(() => {
        scaleDownTitle().then(() => $title.addClass('banner__title--active'));
        $window.on(
            'resize:width',
            debounce(() => {
                $title.css('font-size', '');
                scaleDownTitle();
            })
        );
    });
}

const scaleDownTitle = () =>
    new Promise((resolve, reject) => {
        if ($title.width() <= $container.width()) {
            resolve('done');
        } else {
            let fontSize = parseInt($title.css('font-size'));
            fontSize -= 5;
            $title.css('font-size', fontSize + 'px');
            resolve(scaleDownTitle());
        }
    });
